import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import ExcelJS from "exceljs";

// import { FormControlLabel, Switch } from "@material-ui/core";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@material-ui/core";
import { Card, CardBody, CardHeader, CardHeaderToolbar } from "../../../../_metronic/_partials/controls";
import Table, { dateFormatter } from "../../../components/tables/table";

import { alertError, alertSuccess } from "../../../../utils/logger";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import { buttonFormatterEditDisableDelete } from "../../../components/tables/buttonFormatterTable";
import { getNonEmpty as getNonEmptyHelper } from "../../../../utils/helpers";

import { changeStatusCustomer, deleteCustomer, getAllCustomers, getCustomerById } from "../../../../api/customer";
import { getPlanCustomerByCustomer } from "../../../../api/planCustomer";
import { getUsersCustomer, getUserCustomerById } from "../../../../api/userCustomer";


function getData(customers) {
  return customers
    .map((customer) => ({
      fullName: customer.fullName,
      cif: customer.cif,
      createdAt: customer.createdAt,
      id: customer._id,
      active: customer.active,
      status: customer.status,
      tmpDescription: customer.tmpDescription,
      pendingMaRequest: customer.pendingMaRequest
    }));
}

/*const initialFilters = {
  active: false,
};*/


export default function CustomersPage() {
  const rolePath = useLocation().pathname.split("/")[1];
  const rolePathUpperCase = rolePath.charAt(0).toUpperCase() + rolePath.slice(1);
  const rolePathSingle = rolePath.slice(0, -1);


  const history = useHistory();
  const user = useSelector((store) => store.authentication?.user, shallowEqual);
  const [refresh, setRefresh] = useState(false);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(null);

  const [customer, setCustomer] = useState(null);
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [isExporting, setIsExporting] = useState(false);
  const [exportDialogOpen, setExportDialogOpen] = useState(false);
  // const [filterOptions, setFilterOptions] = useState(initialFilters);


  const columns = [
    { dataField: "fullName", text: "Legal name", sort: true },
    { dataField: "cif", text: "CIF", sort: true },
    {
      dataField: "createdAt",
      text: "Created at",
      formatter: dateFormatter,
      sort: true,
    },
    {
      dataField: "tmpDescription",
      text: "",
      formatter: (cell, row) => {
        const hasTmpDescription = row.tmpDescription && row.tmpDescription !== "";
        const hasPendingMaRequest = !!row.pendingMaRequest;
        if (!hasTmpDescription && !hasPendingMaRequest) return null;

        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-exclamation-triangle" viewBox="0 0 16 16">
            <path d="M7.938 2.016A.13.13 0 0 1 8.002 2a.13.13 0 0 1 .063.016.15.15 0 0 1 .054.057l6.857 11.667c.036.06.035.124.002.183a.2.2 0 0 1-.054.06.1.1 0 0 1-.066.017H1.146a.1.1 0 0 1-.066-.017.2.2 0 0 1-.054-.06.18.18 0 0 1 .002-.183L7.884 2.073a.15.15 0 0 1 .054-.057m1.044-.45a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767z" />
            <path d="M7.002 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0M7.1 5.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0z" />
          </svg>
        );
      },
      headerStyle: { width: '40px' }
    },
    {
      dataField: "id", text: "",
      formatter: (cell) => buttonFormatterEditDisableDelete(cell, rolePathSingle, data, user?.role === "admin", setCustomer, setOpenConfirmDialog, history),
      headerStyle: { width: '200px' }
    },
  ];

  useEffect(() => {
    getAllCustomers(rolePathSingle)
      .then((res) => {
        const data = getData(res.data)
        setData(data);
        setFilteredData(data);
        setRefresh(false);
      })
      .catch((error) => {
        alertError({ error, customMessage: `Could not get ${rolePath}.` });
      });
  }, [refresh, rolePath, rolePathSingle]);

  /*const handleSearch = () => {
    if (!data.length)
      return;
    setFilteredData(
      data.filter((item) => {
        let filter = true;
        if (filterOptions.active)
          filter = filter && item.active;
        return filter;
      })
    );
  };

  const handleClearFilters = () => {
    setFilterOptions(initialFilters);
    setRefresh(true);
  };

  const renderFiltersContent = () => (
    <>
      <br />
      <FormControlLabel
        control={
          <Switch
            checked={filterOptions.active}
            onChange={() =>
              setFilterOptions({
                ...filterOptions,
                active: !filterOptions.active,
              })
            }
            name="checkActive"
          />
        }
        label={filterOptions.active ? "Only active" : "All active/inactive"}
      />
    </>
  );*/

  const getNonEmpty = (value) => {
    if (!value) return "";
    if (typeof value === "string") return value;
    if (typeof value === "object") {
      // Si es un objeto con propiedades de idioma, usar la función helper
      if (value.en || value.es || value.title) {
        const result = getNonEmptyHelper(value);
        return result !== "----" ? result : "";
      }
      // Si tiene propiedad name (como Country)
      if (value.name) return value.name;
      // Si es un array, devolver string vacío (se manejará en el mapeo)
      if (Array.isArray(value)) return "";
    }
    return "";
  };

  const formatDate = (date) => {
    if (!date) return "";
    try {
      return new Date(date).toLocaleDateString("es-ES");
    } catch {
      return "";
    }
  };

  const exportToExcel = async (exportAll = false) => {
    setIsExporting(true);
    setExportDialogOpen(false);
    try {
      // Obtener todos los customers según la opción seleccionada
      let customersResponse;
      if (exportAll) {
        // Exportar todos los customers (sellers, buyers, advisors)
        customersResponse = await getAllCustomers("seller,buyer,advisor");
      } else {
        // Exportar solo el tipo actual
        customersResponse = await getAllCustomers(rolePathSingle);
      }
      const customers = customersResponse.data;

      // Preparar datos para exportar
      const exportData = [];

      for (const customerItem of customers) {
        // Obtener datos completos del customer
        const customerFullResponse = await getCustomerById(customerItem._id);
        const customerFull = customerFullResponse.data;

        // Obtener suscripciones del customer
        let subscriptions = [];
        try {
          const planResponse = await getPlanCustomerByCustomer(customerItem._id);
          subscriptions = planResponse.data || [];
        } catch (error) {
          console.error(`Error getting plans for customer ${customerItem._id}:`, error);
        }

        // Obtener usuarios de este customer (usar los que vienen del customer completo)
        const customerUsersFromFull = customerFull.userCustomer || [];
        
        // Obtener usuarios con preferencias populadas
        const customerUsers = [];
        for (const user of customerUsersFromFull) {
          try {
            // Obtener usuario completo con preferencias populadas
            const userFullResponse = await getUserCustomerById(user._id);
            if (userFullResponse.data) {
              const userData = userFullResponse.data;
              // Debug: verificar si las preferencias están populadas
              if (userData.preferences?.technologies?.length > 0) {
                const firstTech = userData.preferences.technologies[0];
                // Si el primer elemento es un string (ObjectId), las preferencias no están populadas
                if (typeof firstTech === 'string') {
                  console.warn(`User ${user._id} has unpopulated preferences (ObjectIds)`);
                }
              }
              customerUsers.push(userData);
            }
          } catch (error) {
            console.error(`Error getting user ${user._id}:`, error);
            // Si falla, usar el usuario básico
            customerUsers.push(user);
          }
        }

        // Obtener emails de administradores (de todos los usuarios del customer)
        const adminEmails = customerUsers
          .filter(u => u.role === 'admin')
          .map(u => u.email)
          .filter(email => email) // Filtrar emails vacíos
          .join(", ");

        // Si no hay usuarios, crear una fila con datos básicos del customer
        if (customerUsers.length === 0) {
          const row = {
            "Company Name": getNonEmpty(customerFull.fullName),
            "VAT Number": customerFull.cif || "",
            "Registration Number": customerFull.registrationNumber || "",
            "Type": customerFull.role?.join(", ") || rolePathSingle,
            "Address": customerFull.address || "",
            "Country": getNonEmpty(customerFull.country),
            "Province": customerFull.province || "",
            "City": customerFull.city || "",
            "Zip Code": customerFull.zipCode || "",
            "Phone Number": customerFull.phoneNumber || "",
              "Email": adminEmails || customerFull.email || "",
              "Website": customerFull.website || "",
              "LinkedIn": customerFull.linkedIn || "",
              // Status: Estado del customer (draft = borrador, review = en revisión, published = publicado)
              "Status": customerFull.status || (customerFull.role?.includes("advisor") ? "review" : "draft"),
            "Active": customerFull.active ? "Yes" : "No",
            "Created At": formatDate(customerFull.createdAt),
            // Preferencias (vacías si no hay usuarios)
            "Preference Countries": "",
            "Preference Technologies": "",
            "Preference Development Status": "",
            "Preference Advisor Services": "",
            "Preference Min Size": "",
            "Preference Max Size": "",
            "Preference Max COD Date": "",
            "Preference Max Target Price": "",
            // Suscripción
            "Subscription Plan": subscriptions.length > 0 ? getNonEmpty(subscriptions[0]?.plan?.title) : "",
            "Subscription Start Date": subscriptions.length > 0 ? formatDate(subscriptions[0]?.startDate) : "",
            "Subscription End Date": subscriptions.length > 0 ? formatDate(subscriptions[0]?.endDate) : "",
            "Subscription Monthly Price": subscriptions.length > 0 ? (subscriptions[0]?.plan?.monthPrice || "") : "",
            "Subscription Annual Price": subscriptions.length > 0 ? (subscriptions[0]?.plan?.yearPrice || "") : "",
          };
          exportData.push(row);
        } else {
          // Crear una fila por cada usuario del customer
          for (const user of customerUsers) {
            const preferences = user.preferences || {};
            
            // Helper para obtener nombres de preferencias (maneja tanto objetos como arrays)
            const getPreferenceNames = (prefArray, type = 'default') => {
              if (!prefArray || !Array.isArray(prefArray) || prefArray.length === 0) return "";
              
              const names = prefArray
                .map((item) => {
                  // Si es un string (ObjectId sin populación), omitir
                  if (typeof item === 'string') {
                    // Verificar si es un ObjectId válido (24 caracteres hexadecimales)
                    if (/^[0-9a-fA-F]{24}$/.test(item)) {
                      return null; // Es un ObjectId sin populación
                    }
                    // Si no es ObjectId, podría ser un nombre directo (para Country)
                    return item;
                  }
                  
                  // Si es un objeto (debería estar populado)
                  if (typeof item === 'object' && item !== null) {
                    // Para Country: tiene 'name' como string
                    if (item.name && typeof item.name === 'string') {
                      return item.name;
                    }
                    
                    // Para Technology, DevelopmentStatus, AdvisorService: tienen 'title' como objeto {en, es}
                    if (item.title) {
                      const name = getNonEmpty(item.title);
                      if (name && name !== "----" && name !== "") {
                        return name;
                      }
                    }
                    
                    // Si tiene directamente en/es (estructura alternativa)
                    if (item.en || item.es) {
                      const name = getNonEmpty(item);
                      if (name && name !== "----" && name !== "") {
                        return name;
                      }
                    }
                    
                    // Si solo tiene _id y posiblemente __v, es un ObjectId sin populación
                    const keys = Object.keys(item);
                    if (keys.length <= 2 && (keys.includes('_id') || keys.includes('__v'))) {
                      return null; // Es un ObjectId sin populación
                    }
                    
                    // Último intento: usar getNonEmpty directamente
                    const name = getNonEmpty(item);
                    if (name && name !== "----" && name !== "") {
                      return name;
                    }
                  }
                  
                  return null;
                })
                .filter(name => name !== null && name !== "");
              
              return names.join(", ");
            };
            
            const row = {
              "Company Name": getNonEmpty(customerFull.fullName),
              "VAT Number": customerFull.cif || "",
              "Registration Number": customerFull.registrationNumber || "",
              "Type": customerFull.role?.join(", ") || rolePathSingle,
              "Address": customerFull.address || "",
              "Country": getNonEmpty(customerFull.country),
              "Province": customerFull.province || "",
              "City": customerFull.city || "",
              "Zip Code": customerFull.zipCode || "",
              "Phone Number": customerFull.phoneNumber || "",
              "Email": adminEmails || user.email || customerFull.email || "",
              "Website": customerFull.website || "",
              "LinkedIn": customerFull.linkedIn || "",
              // Status: Estado del customer (draft = borrador, review = en revisión, published = publicado)
              "Status": customerFull.status || (customerFull.role?.includes("advisor") ? "review" : "draft"),
              "Active": customerFull.active ? "Yes" : "No",
              "Created At": formatDate(customerFull.createdAt),
              // Preferencias (Countries tienen 'name', otros tienen 'title')
              "Preference Countries": getPreferenceNames(preferences.countries, 'country'),
              "Preference Technologies": getPreferenceNames(preferences.technologies, 'technology'),
              "Preference Development Status": getPreferenceNames(preferences.devStatus, 'devStatus'),
              "Preference Advisor Services": getPreferenceNames(preferences.adService, 'advisorService'),
              "Preference Min Size": preferences.minSize !== undefined && preferences.minSize !== null ? preferences.minSize : "",
              "Preference Max Size": preferences.maxSize !== undefined && preferences.maxSize !== null ? preferences.maxSize : "",
              "Preference Max COD Date": preferences.maxCodDate || "",
              "Preference Max Target Price": preferences.maxTargetPrice !== undefined && preferences.maxTargetPrice !== null && preferences.maxTargetPrice !== -1 ? preferences.maxTargetPrice : "",
              // Suscripción
              "Subscription Plan": subscriptions.length > 0 ? getNonEmpty(subscriptions[0]?.plan?.title) : "",
              "Subscription Start Date": subscriptions.length > 0 ? formatDate(subscriptions[0]?.startDate) : "",
              "Subscription End Date": subscriptions.length > 0 ? formatDate(subscriptions[0]?.endDate) : "",
              "Subscription Monthly Price": subscriptions.length > 0 ? (subscriptions[0]?.plan?.monthPrice || "") : "",
              "Subscription Annual Price": subscriptions.length > 0 ? (subscriptions[0]?.plan?.yearPrice || "") : "",
            };
            exportData.push(row);
          }
        }
      }

      // Crear workbook usando exceljs
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet(exportAll ? "All Customers" : rolePathUpperCase);

      // Obtener las claves de las columnas (encabezados)
      const headers = exportData.length > 0 ? Object.keys(exportData[0]) : [];

      // Agregar encabezados con estilo
      const headerRow = worksheet.addRow(headers);
      headerRow.font = { bold: true };
      headerRow.alignment = { horizontal: "center", vertical: "middle" };
      headerRow.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFE0E0E0" }
      };

      // Agregar datos
      exportData.forEach((row) => {
        const values = headers.map((header) => row[header] || "");
        worksheet.addRow(values);
      });

      // Ajustar ancho de columnas
      const colWidths = [
        25, // Company Name
        15, // VAT Number
        20, // Registration Number
        15, // Type
        30, // Address
        15, // Country
        15, // Province
        15, // City
        10, // Zip Code
        15, // Phone Number
        25, // Email
        25, // Website
        25, // LinkedIn
        12, // Status
        8,  // Active
        12, // Created At
        25, // Preference Countries
        30, // Preference Technologies
        25, // Preference Development Status
        25, // Preference Advisor Services
        15, // Preference Min Size
        15, // Preference Max Size
        20, // Preference Max COD Date
        20, // Preference Max Target Price
        20, // Subscription Plan
        20, // Subscription Start Date
        20, // Subscription End Date
        20, // Subscription Monthly Price
        20, // Subscription Annual Price
      ];

      headers.forEach((header, index) => {
        if (colWidths[index]) {
          worksheet.getColumn(index + 1).width = colWidths[index];
        }
      });

      // Generar buffer y descargar
      const fileName = exportAll 
        ? `All_Customers_export_${new Date().toISOString().split("T")[0]}.xlsx`
        : `${rolePathUpperCase}_export_${new Date().toISOString().split("T")[0]}.xlsx`;
      
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = fileName;
      link.click();
      window.URL.revokeObjectURL(url);

      alertSuccess({
        title: "Exported!",
        customMessage: exportAll 
          ? "All customers data exported successfully."
          : `${rolePathUpperCase} data exported successfully.`,
      });
    } catch (error) {
      console.error("Error exporting to Excel:", error);
      alertError({
        error,
        customMessage: `Could not export ${rolePath} data.`,
      });
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <Card>
      <CardHeader title={`${rolePathUpperCase} list`}>
        <CardHeaderToolbar>
          <button
            type="button"
            className="btn btn-success text-white mr-2"
            onClick={() => setExportDialogOpen(true)}
            disabled={isExporting}
          >
            {isExporting ? "Exporting..." : "Export to Excel"}
          </button>
          <button
            type="button"
            className="btn btn-primary text-white"
            onClick={() => history.push(`/edit-${rolePathSingle}`)}
          >
            Add new
          </button>
        </CardHeaderToolbar>
      </CardHeader>
      <CardBody>
        {/*<FiltersCard
            filtersContent={renderFiltersContent}
            collapsed={collapsed}
            setCollapsed={setCollapsed}
            handleClearFilters={handleClearFilters}
            handleSearch={handleSearch}
          />*/}

        <Table
          key={data.length}
          data={filteredData}
          columns={columns}
          rowClasses={(row) =>
            row.active === false ||
            row?.status?.toLowerCase() === "review" ||
            row?.status?.toLowerCase() === "rejected" ||
            (row.tmpDescription && row.tmpDescription !== "") ||
            row.pendingMaRequest
              ? "inactive-row"
              : row?.status?.toLowerCase() === "published"
              ? "green"
              : ""
          }
        />

        <ConfirmDialog
          title={`Are you sure you want to ${customer?.active ? "disable" : "enable"
            } this ${rolePathSingle}?`}
          open={openConfirmDialog === 1}
          setOpen={setOpenConfirmDialog}
          onConfirm={() => {
            changeStatusCustomer(customer.id, !customer?.active)
              .then((res) => {
                alertSuccess({
                  title: `${customer?.active ? "Disabled!" : "Enabled!"}`,
                  customMessage: `Seller ${customer?.active ? "disabled" : "enabled"
                    } successfully`,
                });
                setRefresh(true);
              })
              .catch((error) => {
                alertError({
                  error,
                  customMessage: `Could not ${customer?.active ? "disable" : "enable"
                    } ${rolePathSingle}.`,
                });
              });
          }}
        />
        <ConfirmDialog
          title={`Are you sure you want to remove this ${rolePathSingle}?`}
          open={openConfirmDialog === 2}
          setOpen={setOpenConfirmDialog}
          onConfirm={() => {
            deleteCustomer(customer.id)
              .then((res) => {
                alertSuccess({
                  title: "Deleted!",
                  customMessage: `${rolePathUpperCase} removed successfully.`,
                });
                setRefresh(true);
              })
              .catch((error) => {
                alertError({
                  error,
                  customMessage: `Could not remove ${rolePathSingle}`,
                });
              });
          }}
        />
        
        <Dialog
          open={exportDialogOpen}
          onClose={() => setExportDialogOpen(false)}
          aria-labelledby="export-dialog-title"
        >
          <DialogTitle id="export-dialog-title">Export to Excel</DialogTitle>
          <DialogContent>
            <p style={{ marginBottom: "16px" }}>Select what you want to export:</p>
            <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
              <Button
                variant="outlined"
                color="primary"
                fullWidth
                onClick={() => exportToExcel(true)}
                disabled={isExporting}
                style={{ textTransform: "none", padding: "10px" }}
              >
                All Customers
              </Button>
              <Button
                variant="outlined"
                color="primary"
                fullWidth
                onClick={() => exportToExcel(false)}
                disabled={isExporting}
                style={{ textTransform: "none", padding: "10px" }}
              >
                Only {rolePathUpperCase}
              </Button>
            </div>
          </DialogContent>
          <DialogActions>
            <Button
              variant="outlined"
              color="secondary"
              onClick={() => setExportDialogOpen(false)}
              disabled={isExporting}
            >
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
      </CardBody>
    </Card>
  );
}